export class ErrorFactoryUtils {
    public static getExceptionMessage(exception:any) : string {
        if (exception.message) {
            return exception.message;
        }

        const details = exception.toString();
        if (details !== {}.toString()) {
            return details;
        }

        return "";
    }
}